import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Meta } from '@angular/platform-browser';
import { Observable, Subscription } from 'rxjs';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { HospitalService } from '../../_services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-blog-details',
  templateUrl: './blog-details.component.html',
  styleUrls: ['./blog-details.component.scss']
})
export class BlogDetailsComponent implements OnInit {
  language: any;
  title: string;
  details:string;
  HospitalBlogs:any[] = [];
  isLoading$: Observable<boolean>;
  private subscriptions: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  Blog:any;
  id;
  constructor(private metaTagService: Meta,private HospitalService: HospitalService,private modalService: NgbModal,
    public dialog: MatDialog,private translationService: TranslationService,private route: ActivatedRoute,private router: Router) { }

  ngOnInit(): void {
    this.metaTagService.updateTag({ 
      name: 'description', 
      content: 'Read our latest article on nutrition and family health, offering expert advice and tips for maintaining a healthy lifestyle.' 
    });
    this.metaTagService.updateTag({ 
      name: 'keywords', 
      content: "nutrition tips, family health, healthy lifestyle, healthcare blog" 
    });
  this.language = this.translationService.getSelectedLanguage();
   const sb = this.HospitalService.GetHospitalBlogs().subscribe(res => {
      if (res.data != null && res.isSuccess)
      {
        this.HospitalBlogs = res.data;
        this.id = this.route.snapshot.params['Id'];
        this.Blog = this.HospitalBlogs.find( x=> x.id == this.route.snapshot.params['Id']);
        if (!this.Blog && this.route.snapshot.params['Id'] != '5c3e8e14-a6ba-434a-a5b1-935b4d08dbc7')
          {
            this.router.navigate(['/blogs']);

          }
      }
    });
    this.subscriptions.push(sb);
    this.isLoading$ = this.HospitalService.isLoading$;

  }

}
